import React from 'react';
import { Link } from "gatsby";
import Layout from "../../layouts/tc";
import eventCover from '../../images/event-logo.jpg';

export default function Home(props) {
  return (
    <Layout location={props.location} title="活動標誌設計及演説比賽">
      <div className="lg:py-20 py-10">
        <div className="container mx-auto px-4 lg:px-0">
          <nav class="mb-4">
            <Link to="/tc">首頁</Link>
            <span class="mx-3 text-gray-700">/</span>
            <span class="text-gray-500">活動標誌設計及演説比賽</span>
          </nav>

          <div className="mt-5">
            <h1 className="text-2xl font-bold">活動標誌設計及演説比賽</h1>

            <div className="mt-5 leading-loose">
              <div>
                <img
                  src={eventCover}
                  className="rounded h-48 lg:float-right lg:block hidden"
                  alt=""
                />
                <p>
                  「活動標誌設計及演説比賽」是EI
                  Fiesta活動之一，由香港教育大學圖書館企業及創新教育組主辦，並獲大學教育資助委員會（教資會）資助。
                </p>
                <p className="mt-3">
                  是次比賽的目的是為EI Fiesta
                  設計一個活動標誌。經評審選出的標誌有機會用於所有線上、印刷、贈品或其他宣傳品等媒體。同時，學生亦有機會通過演説短片詳細闡述其設計概念。
                </p>
              </div>
              <div className="mt-10">
                <h3 className="font-bold text-lg">對象</h3>
                <p>
                  歡迎所有教大學生以個人或團隊名義參加比賽。
                  每位學生或團隊最多可以提交兩個參賽作品(即兩個設計)。
                </p>
              </div>
              <div className="mt-10">
                <h3 className="font-bold text-lg">獎項</h3>
                <p>
                  同學可以個人或團隊形式提交活動標誌設計及演說短片，以爭奪以下三個獎項:
                </p>
                <table class="w-full bg-orange-50 table-fixed my-3">
                  <thead>
                    <tr>
                      <th class="border border-black px-2 py-2 text-left">
                        獎項
                      </th>
                      <th class="border border-black px-2 py-2 text-left">
                        評審機制
                      </th>
                      <th class="border border-black px-2 py-2 text-left">
                        獎品
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="border border-black px-2 py-2">
                        「最佳活動標誌設計獎」
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        由大學圖書館同事和老師組成的評審小組將根據以下標準評核：
                        <ul className="list-disc ml-5">
                          <li>與 EI Fiesta 的主題和目標的相關性（40%）</li>
                          <li>原創性和創意 (30%)</li>
                          <li>審美和設計品質 (30%)</li>
                        </ul>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        <ul className="list-disc ml-5">
                          <li>$1,500 誠品禮券書券及獎狀</li>
                          <li>
                            該標誌將被製作成紀念品，以及作日後活動宣傳之用
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td class="border border-black px-2 py-2">
                        「最佳演說大獎」
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        由大學圖書館同事和老師組成的評審小組將根據以下標準評核：
                        <ul className="list-disc ml-5">
                          <li>闡述設計概念的清晰度（40%）</li>
                          <li>自信（40%）</li>
                          <li>觀眾參與投入度 (20%)</li>
                        </ul>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        $1,500誠品禮券書券及獎狀
                      </td>
                    </tr>
                    <tr>
                      <td class="border border-black px-2 py-2">
                        「大眾選擇大獎」
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        符合資格的標誌設計將於2022 年 4 月 22 日至 2022 年 4 月
                        28日中午12時期間於社交平台“Instagram”
                        企業及創新教育組專頁發佈並進行投票。獲得最多“Like”的作品，得獎者將獲得$1,500書券及獎狀
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        $1,500誠品禮券書券及獎狀
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-10">
                <h3 className="font-bold text-lg">比賽時間表</h3>
                <table class="w-full bg-orange-50 table-auto my-3">
                  <tbody>
                    <tr>
                      <td width="33%" class="border border-black px-2 py-2">
                        <b>2022 年 4 月 20 日下午5時正</b>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        <b>截止報名: 2022 年 4 月 20 日下午5時正</b>
                        <p>
                          有興趣的同學請填妥
                          <a
                            href="https://eduhk.au1.qualtrics.com/jfe/form/SV_8BTdHu8eQI5TY8K"
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-600 hover:text-blue-700 underline"
                          >
                            報名表
                          </a>
                          ，並提交:
                        </p>
                        <ul className="list-disc ml-5">
                          <li>標誌設計 ( .jpeg 或.png格式); 和</li>
                          <li>
                            長約1 分鐘的演説短片*（.mpeg 或 .mp4
                            格式）以演說作品設計意念及構思。
                          </li>
                        </ul>
                        <p className="mt-3">
                          每位學生或團隊最多可以提交兩個參賽作品。
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td width="33%" class="border border-black px-2 py-2">
                        <b>2022 年 4 月 22 日至 2022年 4 月28日中午十二時正</b>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        <b>投票選出「大眾選擇大獎」</b>
                        <p>
                          符合資格的標誌設計將於社交平台“Instagram”
                          企業及創新教育組專頁發佈，並進行投票。
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td width="33%" class="border border-black px-2 py-2">
                        <b>2022 年 4 月 29 日</b>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        <b>公佈結果</b>
                        <p>
                          「最佳活動標誌設計獎」、「最佳演說大獎」和「大眾選擇大獎」的得獎名單將於企業及創新教育組網站公佈。
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  * 鼓勵有興趣參賽的同學參加將於4月11日舉行的「
                  <Link
                    to="/tc/activities/workshop-effective-presentation-storytelling-skills"
                    className="text-blue-600 hover:text-blue-700 underline"
                  >
                    有效演講及說故事技巧工作坊
                  </Link>
                  」，以學習如何更有效地演說其設計意念及構思。
                </p>
              </div>

              <div className="mt-10">
                <h3 className="font-bold text-lg">作品提交</h3>
                <p>
                  有興趣的同學請於2022 年 4 月 20 日下午5時正前填妥以下報名表。
                </p>
                <a
                  href="https://eduhk.au1.qualtrics.com/jfe/form/SV_8BTdHu8eQI5TY8K"
                  className="cta mt-2 inline-block"
                  target="_blank"
                  rel="noreferrer"
                >
                  提交報名表
                </a>
              </div>

              <div className="mt-10" id="regulations">
                <h3 className="font-bold text-lg">參賽規則</h3>
                <div className="mt-3 pl-5">
                  <ol className="list-decimal regulations">
                    <li>
                      個人或團隊最多可以提交兩個參賽作品，額外的參賽作品均不予考慮。
                    </li>
                    <li>
                      所有參賽作品必須是原創作品，不得包含、基於或衍生於任何已存在或由第三方設計、專利、商標或受版權保護的圖像。
                    </li>
                    <li>
                      所有含違法元素的參賽作品均不予考慮。所有提交的物品必須完全遵守香港所有法律，並不得：
                      <ol className="list-alpha pl-5">
                        <li>包含任何不雅、挑釁、誹謗和散佈仇恨的內容；</li>
                        <li>促進非法行為；</li>
                        <li>支持種族、宗教、性別或其他令人反感的偏見；</li>
                        <li>提倡性別或暴力剝削；</li>
                        <li>侵犯法律或協定確立的權利；</li>
                        <li>侵犯任何人的隱私；或</li>
                        <li>任何企業及創新教育組認為不合適的內容。</li>
                      </ol>
                    </li>
                    <li>
                      所有參賽作品將成為香港教育大學圖書館企業及創新教育組的財產。
                    </li>
                    <li>
                      若參與者遞交作品，即代表同意:
                      <ol className="list-alpha pl-5">
                        <li>
                          轉讓標誌設計中任何和所有的知識產權予香港教育大學圖書館企業及創新教育組;
                          及
                        </li>
                        <li>
                          參賽者姓名、獎項、演說片段和報名表上提供的資料可用於宣傳，無需進一步得到許可或補償。
                        </li>
                      </ol>
                    </li>
                    <li>
                      企業及創新教育組保留修改和編輯獲選標誌（「最佳活動標誌設計獎」得獎作品）以更切合活動主題，並無需提供任何理由下拒絕任何參賽作品。
                    </li>
                    <li>
                      「最佳活動標誌設計獎」得獎者必須提交作品高解像度的矢量圖（例如
                      Adobe Illustrator、Photoshop 或 InDesign
                      ），檔案必須為可調整大小,
                      能以彩色或黑白色使用，以便用於電子和印刷媒體。
                    </li>
                    <li>
                      「最佳活動標誌設計獎」得獎作品將被用於製作成EI
                      Fiesta紀念品
                      、用於日後宣傳品或其他企業及創新教育組認為合適的用途。
                    </li>
                    <li>如有任何爭議，企業及創新教育組擁有最終決定權。</li>
                    <li>
                      如評審小組未收到合適的參賽作品，評審小組保留不頒發
                      「最佳活動標誌設計獎」的權利。
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};